import { useEffect, useRef } from 'react'
import { Flex, Text, Link, InjectedModalProps, useModal } from 'vvs-uikit'
import useAuth from 'hooks/useAuth'
import { useTranslation } from 'contexts/Localization'
import { useAcceptance } from 'state/vvsgotchi/hooks/useSignAuthAndAcceptance'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'
import { GotchiModal } from 'views/VvsGotchi/components/Modal'
import ActionButton from 'views/VvsGotchi/components/ActionButton'
import { TERMS_AND_CONDITIONS_URL } from 'config/constants/vvsgotchi'

const AcceptanceModal: React.FC<
  InjectedModalProps & {
    signToAccept: () => Promise<void>
  }
> = ({ onDismiss, signToAccept }) => {
  const { t } = useTranslation()

  return (
    <GotchiModal onDismiss={onDismiss}>
      <Flex justifyContent="center" pb={3} mb={4}>
        <PixelatedImage src="/images/vvsGotchi/vvsgotchi_logo_lg.svg" alt="VvsGotchi Logo" width="224px" />
      </Flex>
      <Text fontSize="20px" fontWeight="600" mb="8px" color="black">
        {t('Welcome to VVSGotchi')}
      </Text>
      <Text fontWeight="600" my="8px" color="black">
        {t('By connecting your wallet and using VVSGotchi, you agree to and acknowledge that you have read our ')}
        <Link display="inline" href={TERMS_AND_CONDITIONS_URL} target="_blank">
          {t('Terms and Conditions')}
        </Link>
        {t('.')}
      </Text>
      <ActionButton mt="16px" onClick={signToAccept}>
        {t('Agree and Sign')}
      </ActionButton>
    </GotchiModal>
  )
}

export const useAcceptanceModal = () => {
  const [requireAcceptance, signToAccept] = useAcceptance()
  const { logout } = useAuth()

  const modalSwitches = useModal(
    <AcceptanceModal signToAccept={signToAccept} />,
    false,
    false,
    'vvsgotchiAcceptance',
    () => requireAcceptance && logout(),
  )
  const modalSwitchesRef = useRef(modalSwitches)
  modalSwitchesRef.current = modalSwitches

  useEffect(() => {
    const [openModal, closeModal] = modalSwitchesRef.current

    if (requireAcceptance) {
      openModal()
    } else {
      closeModal()
    }
  }, [requireAcceptance])
}
